require('./RAWizard.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classnames = require('classnames');
const Immutable = require('immutable');
const { get } = require('lodash');
const { withRouter } = require('react-router-dom');

//@actions
const wizardActions = require('../../actions/RAWizard');
const suitabilityActions = require('../../actions/RASuitabilityTest');

// @commons
const { FormattedText, formatText } = require('core/i18n').i18n;
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKButton } = require('components/commons/OKButton/OKButton');

// @components
const PreLeaveModalComponent = require('components/preLeaveModalComponent/preLeaveModalComponent');
const RAActionLink = require('./RAActionLink');

// @constants
const {
    MYPROFILE_BROKER_ROBO_URL,
    SUITABILITY_TEST,
    SUITABILITY_TEST_STEP_1,
    SUITABILITY_TEST_STEP_4,
    SUITABILITY_TEST_STEP_5,
    SUITABILITY_TEST_STEP_11,
    STEP_NUMBER_10,
    STEP_NUMBER_11,
    STEP_NUMBER_12,
    STEP_NUMBER_13,
    SUITABILITY_TEST_ACCORDION_QUESTION,
    SUITABILITY_TEST_TOTAL_ANSWERS_TO_VALIDATE,
} = require('../../raConstants/index');
const { SUITABILITY_TEST_V6 } = require('constants/flagBasedFeatures');

// @utilities
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { recordLink } = require('utilities/tagging');
const {
    isQuestionAnswered,
} = require('../../utilities/RASuitabilityTestHelper');

class RAWizard extends React.Component {
    constructor(props) {
        super(props);
        this.parseChildren = this.parseChildren.bind(this);
        this.handleStepClick = this.handleStepClick.bind(this);
        this.handleToggleCategory = this.handleToggleCategory.bind(this);

        this.handlePreviousStep = this.handlePreviousStep.bind(this);
        this.handleNextStep = this.handleNextStep.bind(this);
        this.modalComponentIsReady = this.modalComponentIsReady.bind(this);
        this.handleOnCancel = this.handleOnCancel.bind(this);
    }

    componentDidMount() {
        const { identifier, lastAnswer, changeStepTo, readOnly } = this.props;

        const categories = this.parseCategories(lastAnswer);
        this.props.initializeWizard(identifier, categories);

        if (lastAnswer && !readOnly) {
            changeStepTo(SUITABILITY_TEST, lastAnswer.stepIndex + 1);
        }
    }

    componentDidUpdate(nextProps) {
        const { identifier, lastAnswer } = this.props;
        if (nextProps.lastAnswer.stepIndex !== lastAnswer.stepIndex) {
            const categories = this.parseCategories(lastAnswer);
            this.props.initializeWizard(identifier, categories);
        }
    }

    componentWillUnmount() {
        this.props.reset();
    }

    parseCategories(lastAnswer) {
        const { readOnly } = this.props;
        const pristineWizard = !lastAnswer;
        const lastAnswerCategoryIndex = readOnly
            ? 0
            : get(lastAnswer, 'step.category', 0);
        const lastAnsweredStepIndex = readOnly
            ? 0
            : get(lastAnswer, 'stepIndex', 0);

        let stepIndex = -1;
        return React.Children.map(
            this.props.children({ disabled: readOnly }),
            (category, categoryIndex) => {
                return {
                    name: category.props.name,
                    icon: category.props.icon,
                    identifier: category.props.identifier,
                    isActive: categoryIndex === lastAnswerCategoryIndex,
                    isExpanded: categoryIndex === lastAnswerCategoryIndex,
                    isExpandable: category.props.isExpandable,
                    isHidden: category.props.isHidden,
                    steps: React.Children.toArray(category.props.children).map(
                        step => {
                            stepIndex++;
                            let isActive =
                                categoryIndex === lastAnswerCategoryIndex &&
                                stepIndex === lastAnsweredStepIndex;
                            let isAvailable =
                                categoryIndex <= lastAnswerCategoryIndex &&
                                stepIndex <= lastAnsweredStepIndex;
                            const isCompleted =
                                step.props.isCompleted ||
                                (isAvailable && !pristineWizard);

                            // When lastAnswer is truthy, we stand on the next question after lastAnswer
                            if (!pristineWizard && !readOnly) {
                                isActive =
                                    stepIndex === lastAnsweredStepIndex + 1;
                                isAvailable = isAvailable || isActive;
                            }

                            return {
                                identifier: step.props.identifier,
                                name: step.props.name,
                                nextButtonLabel: step.props.nextButtonLabel,
                                isCompleted,
                                isActive,
                                isAvailable,
                                canContinue: step.props.canContinue,
                                shouldDisplayModal:
                                    step.props.shouldDisplayModal,
                                isNavigatable: step.props.isNavigatable,
                            };
                        },
                    ),
                };
            },
        );
    }

    parseChildren() {
        const { readOnly } = this.props;
        const steps = [];

        React.Children.forEach(
            this.props.children({ disabled: readOnly }),
            category => {
                React.Children.forEach(category.props.children, step => {
                    const children = step.props.children;
                    // Remove key warning when a step have more than one element as children
                    if (Array.isArray(children)) {
                        const newChildren = React.Children.map(
                            children,
                            (child, i) => {
                                const id =
                                    step.props.key || step.props.identifier;
                                const key = `${id}_${i}`;

                                return React.cloneElement(child, { key });
                            },
                        );

                        steps.push(
                            React.cloneElement(step, { children: newChildren }),
                        );
                    } else {
                        steps.push(step);
                    }
                });
            },
        );

        return steps;
    }

    modalComponentIsReady() {
        recordLink('test idoneidad', 'vista modal salir');
        return this.props.readOnly;
    }

    buildLeaveModal() {
        const {
            leaveModalMessage,
            leaveModalTitle,
            leaveModalAcceptButtonText,
            leaveModalCancelButtonText,
        } = this.props;

        const confirmationMessage =
            leaveModalMessage === undefined
                ? formatText('roboWizard-leaveConfirmationMessage')
                : leaveModalMessage;
        const confirmationTitle =
            leaveModalTitle === undefined
                ? formatText('roboWizard-leaveConfirmationTitle')
                : leaveModalTitle;
        const acceptText =
            leaveModalAcceptButtonText === undefined
                ? formatText('roboWizard-leaveAcceptText')
                : leaveModalAcceptButtonText;
        const cancelText =
            leaveModalCancelButtonText === undefined
                ? formatText('roboWizard-leaveCancelText')
                : leaveModalCancelButtonText;

        const dataToRender = (
            <PreLeaveModalComponent
                onConfirmLeave={this.props.handleCancel}
                confirmationMessage={confirmationMessage}
                confirmationTitle={confirmationTitle}
                acceptText={acceptText}
                cancelText={cancelText}
                isReady={this.modalComponentIsReady}
            />
        );

        return dataToRender;
    }

    handleStepClick(destination) {
        const { immWizard, identifier } = this.props;
        const currentStepIndex = immWizard.getIn([
            'persistedWizards',
            identifier,
            'currentStepIndex',
        ]);
        scrollToTop();
        this.props.handleNavigationRequest(
            identifier,
            currentStepIndex,
            destination,
        );
    }

    handlePreviousStep() {
        const { identifier, immFlagBasedFeatures } = this.props;
        const immCurrentWizard = this.props.immWizard.getIn([
            'persistedWizards',
            identifier,
        ]);
        const currentStep = immCurrentWizard.getIn([
            'categories',
            immCurrentWizard.get('currentCategory'),
            'steps',
            immCurrentWizard.get('currentStep'),
        ]);
        if (
            currentStep.get('identifier') === SUITABILITY_TEST_STEP_5 &&
            this.props.immSuitabilityTest.getIn(['answers', '101']) ===
                'answer1' &&
            !immFlagBasedFeatures.get(SUITABILITY_TEST_V6)
        ) {
            this.handleStepClick(0);
        } else {
            this.handleStepClick('-1');
        }
    }

    handleNextStep() {
        const {
            identifier,
            readOnly,
            immSuitabilityTest,
            sendLogs,
            immFlagBasedFeatures,
        } = this.props;
        const immCurrentWizard = this.props.immWizard.getIn([
            'persistedWizards',
            identifier,
        ]);
        const ffTestV6 = immFlagBasedFeatures.get(SUITABILITY_TEST_V6);
        const currentStep = immCurrentWizard.getIn([
            'categories',
            immCurrentWizard.get('currentCategory'),
            'steps',
            immCurrentWizard.get('currentStep'),
        ]);
        sendLogs(currentStep.get('identifier'));
        if (
            currentStep.get('identifier') !== SUITABILITY_TEST_STEP_1 &&
            currentStep.get('shouldDisplayModal') &&
            !readOnly
        ) {
            this.props.showModal(identifier, true);
        } else if (currentStep.get('identifier') === SUITABILITY_TEST_STEP_4) {
            const shouldShowModalForStep4 = SUITABILITY_TEST_ACCORDION_QUESTION.every(
                a =>
                    immSuitabilityTest.getIn(['answers', a.toString()]) ===
                    'answer1',
            );
            if (shouldShowModalForStep4) {
                this.props.showModal(identifier, true);
            } else {
                this.handleStepClick('+1');
            }
        } else if (
            currentStep.get('identifier') === SUITABILITY_TEST_STEP_1 &&
            !ffTestV6 &&
            immSuitabilityTest.getIn(['answers', '101']) === 'answer1'
        ) {
            this.props.showFirstAnswerModal(identifier, true);
        } else {
            this.handleStepClick('+1');
        }
    }

    handleToggleCategory(categoryIdentifier) {
        this.props.toggleExpandInCategoryMenu(
            this.props.identifier,
            categoryIdentifier,
        );
    }

    renderStepLink(name, identifier, isCompleted, isActive, isAvailable) {
        const { allowSidebarNavigation, readOnly } = this.props;

        if (
            allowSidebarNavigation &&
            (isCompleted || isActive || isAvailable || readOnly)
        ) {
            return <RAActionLink param={identifier}>{name}</RAActionLink>;
        }
        return name;
    }

    renderCategories(immCategories) {
        const { readOnly } = this.props;
        const categoriesHeader = this.props.categoriesHeader;

        return immCategories.reduce((acc, category, catKey) => {
            if (catKey === 0 && categoriesHeader) {
                acc.push(categoriesHeader);
            }
            const isElevenQuestionCargory =
                category.get('identifier') === SUITABILITY_TEST_STEP_11;
            const categoryTitleClassNames = classnames(
                'robowizard-sidebar__category__title',
                {
                    'robowizard-sidebar__category__title--active': category.get(
                        'isActive',
                    ),
                },
            );

            const isExpanded = readOnly || category.get('isExpanded');
            const stepsClassNames = classnames('robowizard-sidebar__steps', {
                'robowizard-sidebar__steps--collapsed': !isExpanded,
            });

            let completedOrIcon;
            if (readOnly) {
                completedOrIcon = 'icon-exito';

                const isSomeStepActive = category
                    .get('steps')
                    .some(step => step.get('isActive'));
                if (isSomeStepActive) {
                    completedOrIcon +=
                        ' robowizard-sidebar__category__title__icon--success';
                } else {
                    completedOrIcon +=
                        ' robowizard-sidebar__category__title__icon--disabled';
                }
            } else {
                completedOrIcon = category
                    .get('steps')
                    .every(step => step.get('isCompleted'))
                    ? 'robowizard-sidebar__category__title__icon--success icon-exito'
                    : isElevenQuestionCargory
                    ? 'robowizard-sidebar__category__title__icon__eleven'
                    : `icon-${category.get('icon')}`;
            }

            const iconClassName = `robowizard-sidebar__category__title__icon ${completedOrIcon}`;

            const categoryName = category.get('name');
            const categoryIdentifier = category.get('identifier');

            const categoryClassNames = classnames(
                'robowizard-sidebar__category',
                {
                    'robowizard-sidebar__category--hidden': category.get(
                        'isHidden',
                    ),
                },
            );

            return acc.concat(
                <li className={categoryClassNames} key={catKey}>
                    <h2 className={categoryTitleClassNames}>
                        <RAActionLink
                            param={categoryIdentifier}
                            onClick={this.handleToggleCategory}
                        >
                            <span className={iconClassName} /> {categoryName}
                        </RAActionLink>
                    </h2>
                    <ul className={stepsClassNames}>
                        {category.get('steps').map((step, stepKey) => {
                            const completed =
                                !readOnly && step.get('isCompleted');
                            const stepClassNames = classnames(
                                'robowizard-sidebar__step',
                                {
                                    'robowizard-sidebar__step--active': step.get(
                                        'isActive',
                                    ),
                                    'robowizard-sidebar__step--completed': completed,
                                    'robowizard-sidebar__step--available': step.get(
                                        'isAvailable',
                                    ),
                                },
                            );
                            const stepLink = this.renderStepLink(
                                step.get('name'),
                                step.get('identifier'),
                                step.get('isCompleted'),
                                step.get('isActive'),
                                step.get('isAvailable'),
                            );

                            return !!step.get('name') ? (
                                <li className={stepClassNames} key={stepKey}>
                                    {stepLink}
                                </li>
                            ) : null;
                        })}
                    </ul>
                </li>,
            );
        }, []);
    }

    renderNavigationButtons(current, total) {
        const {
            immWizard,
            answeredQuestionIds,
            identifier,
            isReviewing,
            onFinish,
            readOnly,
            finishLoading,
            immSuitabilityTest,
            immFlagBasedFeatures,
        } = this.props;
        const ffTestV6 = immFlagBasedFeatures.get(SUITABILITY_TEST_V6);
        const immCurrentWizard = immWizard.getIn([
            'persistedWizards',
            identifier,
        ]);
        const immCurrentStep = immCurrentWizard.getIn(
            [
                'categories',
                immCurrentWizard.get('currentCategory'),
                'steps',
                immCurrentWizard.get('currentStep'),
            ],
            Immutable.Map(),
        );
        const currentStepIndex = immWizard.getIn([
            'persistedWizards',
            identifier,
            'currentStepIndex',
        ]);
        const questionWasAnswered = isQuestionAnswered(
            currentStepIndex,
            answeredQuestionIds,
            readOnly,
            immSuitabilityTest,
        );
        const canContinue = immCurrentStep.get('canContinue');
        const nextButtonLabel = immCurrentStep.get('nextButtonLabel');
        const zeroQuestionWasAnsweredInPicaso =
            __CONTACT_CENTER__ &&
            !!immSuitabilityTest.getIn(['answers', '702']);
        let sustainabilityQuestionStep = 0;

        if (ffTestV6) {
            sustainabilityQuestionStep = zeroQuestionWasAnsweredInPicaso
                ? STEP_NUMBER_12
                : STEP_NUMBER_11;
        } else {
            sustainabilityQuestionStep = zeroQuestionWasAnsweredInPicaso
                ? STEP_NUMBER_11
                : STEP_NUMBER_10;
        }
        const isUserChoosingAnswer1 =
            current === sustainabilityQuestionStep &&
            this.props.immSuitabilityTest.getIn(['answers', '401']) ===
                'answer1';

        const previousButton =
            current > 0 ? (
                <div className="robowizard-step__actions-buttons">
                    <OKButton
                        modifier="ghost"
                        onClick={this.handlePreviousStep}
                    >
                        <FormattedText value="roboWizard-previous" />
                    </OKButton>
                </div>
            ) : null;
        const canGoNext =
            readOnly || isReviewing || questionWasAnswered || canContinue;
        const nextButton =
            current < total - 1 && !isUserChoosingAnswer1 ? (
                <div className="robowizard-step__actions-buttons">
                    <OKButton
                        modifier="secondary"
                        onClick={this.handleNextStep}
                        disabled={!canGoNext}
                        key={currentStepIndex}
                    >
                        {!!nextButtonLabel ? (
                            <span>{nextButtonLabel}</span>
                        ) : (
                            <FormattedText value="roboWizard-next" />
                        )}
                    </OKButton>
                </div>
            ) : null;

        const answerThreeQuestion402 =
            immSuitabilityTest.getIn(['answers', '402']) === 'answer3';
        const otherAnswersQuestion402 =
            immSuitabilityTest.getIn(['answers', '402']) === 'answer2' ||
            immSuitabilityTest.getIn(['answers', '402']) === 'answer1';
        const questionsToValidate = ['403', '404', '405'];

        const questionsWithAnswer = questionsToValidate.filter(item => {
            return (
                immSuitabilityTest.getIn(['answers', item]) !== '' &&
                immSuitabilityTest.getIn(['answers', item]) !== undefined &&
                item
            );
        });
        let suitabilityTestQuestion402Step = 0;
        if (ffTestV6) {
            suitabilityTestQuestion402Step = zeroQuestionWasAnsweredInPicaso
                ? STEP_NUMBER_13
                : STEP_NUMBER_12;
        } else {
            suitabilityTestQuestion402Step = zeroQuestionWasAnsweredInPicaso
                ? STEP_NUMBER_12
                : STEP_NUMBER_11;
        }

        const canFinish =
            current === suitabilityTestQuestion402Step
                ? otherAnswersQuestion402 ||
                  (answerThreeQuestion402 &&
                      questionsWithAnswer.length ===
                          SUITABILITY_TEST_TOTAL_ANSWERS_TO_VALIDATE)
                : !readOnly &&
                  (isReviewing || questionWasAnswered || canContinue);
        let finishButton;
        if (current === total - 1 || isUserChoosingAnswer1) {
            finishButton = this.props.finishButton ? (
                this.props.finishButton
            ) : (
                <div className="robowizard-step__actions-buttons">
                    <OKButton
                        modifier="primary"
                        onClick={() => onFinish(total)}
                        disabled={!canFinish}
                        loading={finishLoading}
                    >
                        <FormattedText value="roboWizard-finish" />
                    </OKButton>
                </div>
            );
        }

        return (
            <div className="robowizard-step__actions">
                {previousButton} {nextButton} {finishButton}
            </div>
        );
    }

    handleOnCancel() {
        this.props.history.replace(MYPROFILE_BROKER_ROBO_URL);
    }

    render() {
        const {
            immWizard,
            identifier,
            handleNavigationRequest,
            displayLeaveModal,
            retryTest,
            showCancelButtonTooltip,
        } = this.props;
        const leaveModal = displayLeaveModal ? this.buildLeaveModal() : null;

        if (!immWizard.get('persistedWizards').has(identifier)) {
            return (
                <div className="robowizard">
                    <LoadingSection />
                </div>
            );
        }

        const currentStepIndex = immWizard.getIn([
            'persistedWizards',
            identifier,
            'currentStepIndex',
        ]);
        const allSteps = this.parseChildren();
        const target = allSteps[currentStepIndex];

        const currentStep = React.cloneElement(target, {
            parent: identifier,
            parentHandleNavigationRequest: handleNavigationRequest,
        });

        const categories = this.renderCategories(
            immWizard.getIn(['persistedWizards', identifier, 'categories']),
        );
        const navigationButtons = this.renderNavigationButtons(
            currentStepIndex,
            allSteps.length,
        );

        let cancelButton;
        if (this.props.cancelButton) {
            cancelButton = this.props.cancelButton;
        } else {
            const button = (
                <span>
                    <OKButton
                        modifier="link-ghost"
                        to={MYPROFILE_BROKER_ROBO_URL}
                        onClick={this.handleOnCancel}
                    >
                        <FormattedText
                            className="robowizard__cancel-button-label"
                            value="raSuitabilityTest-cancel"
                        />
                    </OKButton>
                </span>
            );

            if (
                (!__CONTACT_CENTER__ && !!retryTest) ||
                (__CONTACT_CENTER__ && showCancelButtonTooltip)
            ) {
                cancelButton = button;
            } else {
                cancelButton = (
                    <OKTooltip
                        content={formatText('raSuitabilityTest-cancelTooltip')}
                        offset={[0, -10]}
                        target={button}
                    />
                );
            }
        }

        return (
            <div className="robowizard">
                <div className="robowizard-sidebar">
                    <div className="robowizard-sidebar__container">
                        <ul className="robowizard-sidebar__categories">
                            {' '}
                            {categories}{' '}
                        </ul>
                        <div className="robowizard__cancel-button">
                            {cancelButton}
                        </div>
                    </div>
                </div>
                <div className="robowizard-content">
                    <div className="robowizard__container">
                        <div className="robowizard-step">
                            <div className="robowizard-step__content">
                                <div className="robowizard-step__element">
                                    {currentStep}
                                </div>
                            </div>
                            <div className="robowizard__buttons">
                                {navigationButtons}
                            </div>
                        </div>
                    </div>
                </div>
                {leaveModal}
            </div>
        );
    }
}

RAWizard.propTypes = {
    identifier: PropTypes.string.isRequired,
    children: PropTypes.any,
    changeStepTo: PropTypes.func,
    handleCancel: PropTypes.func,
    handleNavigationRequest: PropTypes.func,
    allowSidebarNavigation: PropTypes.bool,
    answeredQuestionIds: PropTypes.array,
    history: PropTypes.object.isRequired,
    immWizard: PropTypes.any, //Injected by connect
    immSuitabilityTest: PropTypes.any, //Injected by connect
    initializeWizard: PropTypes.func, //Injected by connect
    isReviewing: PropTypes.bool,
    toggleExpandInCategoryMenu: PropTypes.func, //Injected by connect
    onFinish: PropTypes.func.isRequired,
    showModal: PropTypes.func,
    showFirstAnswerModal: PropTypes.func,
    readOnly: PropTypes.bool,
    cancelButton: PropTypes.element,
    finishButton: PropTypes.element,
    categoriesHeader: PropTypes.element,
    lastAnswer: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
    finishLoading: PropTypes.bool,
    reset: PropTypes.func.isRequired,
    retryTest: PropTypes.bool,
    displayLeaveModal: PropTypes.bool.isRequired,
    leaveModalMessage: PropTypes.string,
    leaveModalTitle: PropTypes.string,
    leaveModalAcceptButtonText: PropTypes.string,
    leaveModalCancelButtonText: PropTypes.string,
    showCancelButtonTooltip: PropTypes.bool,
    sendLogs: PropTypes.func,
    immFlagBasedFeatures: PropTypes.any, //Injected by connect
};

RAWizard.defaultProps = {
    allowSidebarNavigation: true,
    isReviewing: false,
    readOnly: false,
    cancelButton: null,
    finishButton: null,
    categoriesHeader: null,
    lastAnswer: false,
    finishLoading: false,
    showCancelButtonTooltip: true,
};

module.exports = connect(
    state => ({
        immWizard: state.raWizard,
        immSuitabilityTest: state.raSuitabilityTest,
        immFlagBasedFeatures: state.flagBasedFeatures,
    }),
    {
        changeStepTo: wizardActions.changeStepTo,
        initializeWizard: wizardActions.initializeWizard,
        showModal: wizardActions.showModal,
        showFirstAnswerModal: wizardActions.showFirstAnswerModal,
        toggleExpandInCategoryMenu: wizardActions.toggleExpandInCategoryMenu,
        reset: wizardActions.reset,
        sendLogs: suitabilityActions.sendLogs,
    },
)(withRouter(RAWizard));
